// @core/api/endpoints/project/update_component.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ComponentResponse,
  UpdateComponentRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Update component
 * Updates component name, description, color, or lead.
 */
export async function UpdateComponent(
  project_id: string,
  component_id: string,
  data: UpdateComponentRequest,
  options?: RequestOptions
): Promise<ComponentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/components/:component_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':component_id', encodeURIComponent(component_id));
  const requestOptions = options;
  return client.put<ComponentResponse>(requestPath, data, requestOptions);
}
